console.log('[WFY] custom.js loaded');

if (typeof html_tag == undefined) { let html_tag = document.documentElement } else { html_tag = document.documentElement }
if (typeof root_styles == undefined) { let root_styles = document.querySelector(':root') } else { root_styles = document.querySelector(':root') }
if (typeof top_id == undefined) { let top_id = document.querySelector('.shopify-section-header') } else { top_id = document.querySelector('.shopify-section-header') }
let nav_top_id = document.querySelector('#nav-top');
if (typeof header_outer == undefined) { let header_outer = document.querySelector('#header-outer') } else { header_outer = document.querySelector('#header-outer') }
let header_id = header_outer ? header_outer.querySelector('#header') : null;
if (typeof header_inner == undefined) { let header_inner = document.querySelector('#header-inner') } else { header_inner = document.querySelector('#header-inner') }
let logo_id = document.querySelector('#logo');
let logo_img = logo_id ? logo_id.querySelector('img') : null;
let search_id = document.querySelector('#search');
let nav_outer = document.querySelector('#nav-outer');
let nav_bar_id = document.querySelector('#nav-bar');
let nav_id = document.querySelector('#nav');
if (typeof content_id == undefined) { let content_id = document.getElementById('content') } else { content_id = document.getElementById('content') }

let html_width = html_tag.getBoundingClientRect().width;
let nav_main = nav_bar_id ?? nav_id;

const asyncOnce = {
    once: true
};
const asyncPass = {
    passive: true,
    once: true
};

let global_dir;
if (html_tag.getAttribute('dir') === 'rtl') {
	global_dir = ['rtl', false];
} else {
	global_dir = ['ltr', true];
}

function isTouchDevice() {
	return window.matchMedia("(pointer: coarse)").matches;
}

const isMobile = window.matchMedia("(pointer: coarse)").matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  
// for (let i = 0; i < img_lazy.length; i = i + 1) {
// 	img_lazy[i].classList.add('lazy');
// 	if (!img_lazy[i].hasAttribute('src')) {
// 		img_lazy[i].setAttribute('src', img_lazy[i].getAttribute('data-src'));
// 	}
// }

var listCollectionSliderEvt = new CustomEvent("listCollectionSlider"),
	semanticSelectEvt = new CustomEvent("semanticSelect"),
	productcardVariantsEvt = new CustomEvent("productcardVariants"),
  quickShopEvt = new CustomEvent('quickShop'),
  ajaxCartEvt = new CustomEvent('ajaxCart'),
	announcementSliderEvt = new CustomEvent("announcementSlider"),
	moduleFeaturedSliderEvt = new CustomEvent("moduleFeaturedSlider"),
	listProductSliderEvt = new CustomEvent("listProductSlider"),
	listUspSliderEvt = new CustomEvent("listUspSlider"),
	listTestimonialsSliderEvt = new CustomEvent("listTestimonialsSlider"),
	listStaticSliderEvt = new CustomEvent("listStaticSlider"),
	searchClassesEvt = new CustomEvent("searchClasses"),
	createColsEvt = new CustomEvent("createCols"),
	moduleTabsEvt = new CustomEvent("moduleTabs"),
	formZindexEvt = new CustomEvent("formZindex"),
	ratingsEvt = new CustomEvent("ratings"),
	inputPaddingEvt = new CustomEvent("inputPadding"),
	topEvt = new CustomEvent("top"),
	backgroundEvt = new CustomEvent("background"),
  lazyVideoEvt = new CustomEvent("lazyVideo"),
  mediaFlexibleEvt = new CustomEvent("mediaFlexbile"),
	setCustomDropHeightEvt = new CustomEvent("setCustomDropHeight");

  function isHasSelectorSupported() {
    const testElement = document.createElement('div');
    try {
      testElement.querySelector(':has(*)');
      return true;
    } catch (error) {
      return false;
    }
  }
  function getSiblings(el) {
    return Array.from(el.parentNode.children).filter(function (sibling) {
      return sibling !== el;
    });
  }

  function append_url(el, content, className, href, access) {
    const link = createElementWithClass('a', className);
    link.href = href || './';
    if (access === true) {
      link.setAttribute('tabindex', -1);
      link.setAttribute('aria-hidden', true);
      link.setAttribute('focusable', false);
    }
    link.innerHTML += content;
    if (el) {
      el.appendChild(link);
    }
  }

  function wrap(el, wrapper, className) {
    el.parentNode.insertBefore(wrapper, el);
    if (className) {
      wrapper.classList.add(className);
    }
    wrapper.appendChild(el);
  }

  function new_css(id, href, media) {
    if (!document.getElementById(id)) {
      const a = document.createElement('link');
      if (media === undefined) {
        media = 'screen';
      }
      a.setAttribute('id', id);
      a.setAttribute('rel', 'stylesheet');
      a.setAttribute('href', href);
      a.setAttribute('media', media);
      a.setAttribute('id', id);

      const b = document.querySelectorAll('link[id]');
      if (b.length) {
        Array.from(b).forEach(function (el) {
          el.after(a);
        });
      } else {
        document.head.appendChild(a);
      }
    }
  }

  function throttle(callback, delay) {
    let timeoutId;
    return function () {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          callback();
          timeoutId = null;
        }, delay);
      }
    };
  }

  function customDropHeight() {
    if (nav_main) {
      const HH_req = ['.m6fr.wide-transparent', '.m6fr.size-xl', '.m6fr article.size-xl'];
      const hasHH = HH_req.some(selector => document.querySelector(selector));

      if (hasHH) {
        requestAnimationFrame(function () {
          if (header_outer && header_inner) {
            const headerHeight = header_outer.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--header_height_static', headerHeight);
          }
          if (nav_top_id) {
            const nav_top_idHeight = nav_top_id.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--nav_top_h', nav_top_idHeight);
          }
        });
      }
    }
  }

  const mediaMax1000 = window.matchMedia('(max-width: 1000px)');
  const mediaMin1000 = window.matchMedia('(min-width: 1001px)');

  let stickyOffsetCalculated = false;
  let stickyOffsetScheduled = false;
  function stickyOffset() {
    if (stickyOffsetScheduled) return;
    stickyOffsetScheduled = true;
    requestAnimationFrame(() => {
      if (!stickyOffsetCalculated && nav_main) {
        const SO_req = ['.m6pr', '[id^="section-"]', '.f8ps', '.f8sr', '.m6cl', '.m6ac'];
        if (header_outer && header_inner) {
          if (SO_req.some(selector => document.querySelector(selector))) {
            const setStickyOffset = () => {
              const height = header_outer.getBoundingClientRect().height + 'px';
              root_styles.style.setProperty('--sticky_offset', height);
            };
              if (header_inner.classList.contains('sticky-nav')) {
                  html_tag.classList.add('has-sticky-nav');
                  /*enquire.register('screen and (max-width: 1000px)', () => {
                      setStickyOffset();
                  }).register('screen and (min-width: 1001px)', () => {
                      const nav_mainHeight = nav_main.getBoundingClientRect().height + 'px';
                      root_styles.style.setProperty('--sticky_offset', nav_mainHeight);
                  });*/
                  function updateSticky() {
                      if (mediaMax1000.matches) {
                          setStickyOffset();
                      } else if (mediaMin1000.matches) {
                          const nav_mainHeight = nav_main.getBoundingClientRect().height + 'px';
                          root_styles.style.setProperty('--sticky_offset', nav_mainHeight);
                      }
                  }

                  updateSticky();

                  mediaMax1000.addEventListener('change', updateSticky);
                  mediaMin1000.addEventListener('change', updateSticky);
              } else {
                  setStickyOffset();
              }
          }
        }
        stickyOffsetCalculated = true;
      }
      stickyOffsetScheduled = false;
    });
  }

  if (!isMobile) {
    document.addEventListener('mouseover', stickyOffset, asyncOnce);
  }
  document.addEventListener('keyup', stickyOffset, asyncOnce);
  document.addEventListener('touchstart', stickyOffset, asyncPass);
  document.addEventListener('scroll', stickyOffset, asyncPass);
  window.addEventListener('resize', throttle(() => {
    stickyOffsetCalculated = false;
    stickyOffset();
  }, 500));


  setTimeout(function () {
    customDropHeight();
  }, 100);
  window.addEventListener('resize', throttle(() => {
    customDropHeight();
    if (header_outer && header_inner) {
      requestAnimationFrame(function () {
        //setTimeout(function () {
        //const header_outerHeight = header_outer.clientHeight + 'px';
        const header_outerHeight = header_outer.getBoundingClientRect().height + 'px';
        root_styles.style.setProperty('--header_height_static', header_outerHeight);
        //}, 500);
      });
    }
  }, 500));
  window.addEventListener("setCustomDropHeight", function(evt) {
    customDropHeight();
  });

// delay scrollbar width
let scrollbarWidthCalculated = false;

function getScrollbarWidth() {
    if (!scrollbarWidthCalculated) {
        requestAnimationFrame(() => {
            const htmlWidth = html_tag.getBoundingClientRect().width;
            const scrollbarWidth = window.innerWidth - htmlWidth;

            root_styles.style.setProperty('--scrollbar_width', scrollbarWidth + 'px');
            scrollbarWidthCalculated = true;
        });
    }
}

// onload
const SB_req = [".m6bx.wide", ".m6fr.wide", ".l4ft.fullwidth", ".l4cl.fullwidth", ".shopify-section-breadcrumbs"];
if (SB_req.some(selector => document.querySelector(selector))) {
    getScrollbarWidth();
}

  
  if (logo_img) {
    if (logo_img.complete) {
      customDropHeight();
    } else {
      logo_img.addEventListener('load', customDropHeight);
    }
  } else {
    customDropHeight();
  }
  
  if (header_inner) {
    if (header_inner.classList.contains('mobile-visible-search')) {
      html_tag.classList.add('has-mobile-visible-search');
    }
    if (header_inner.classList.contains('t1nn')) {
      html_tag.classList.add('t1nn');
    }
  }
  
  if (content_id && header_inner) {
    const ffa = content_id.children[0];
    let ffc;
    let ffd = false;
    let ffe = false;
  
  
    if (ffa) {
      ffc = ffa.children[0];
      if (ffa.classList.contains('shopify-section') && header_inner.hasAttribute('data-transparent')) {
        ffd = true;
      }
  
      if (ffc && (ffc.classList.contains('m6bx') || ffc.classList.contains('m6fr')) && ffc.classList.contains('wide')) {
        ffe = true;
        ffc.classList.add('im-tr');
      }
      const announcementBar = document.querySelector('.shopify-section-header ~ [class*="shopify-section-announcement-bar"]');
      if (announcementBar) {
        ffd = false;
      }
      if (ffd && ffe && ffc && ffc.classList.contains('wide-transparent')) {
        top_id.classList.add('transparent');
        html_tag.classList.add('has-first-m6fr-wide');
        if (ffc.classList.contains('m6bx')) {
          html_tag.classList.add('has-first-m6bx-wide');
        }
      } else {
        header_inner.classList.remove('transparent');
      }
    }
  }

function create_slider(el, settings, minSlides) {
    const imgOverlays = [];
    let bg = false;
    const children = el.children;

    if (el.getElementsByClassName('img-overlay').length) {
        Array.from(children).forEach(child => {
            if (child.classList.contains('img-overlay')) {
                bg = true;
                imgOverlays.push(child);
                child.remove();
            }
        });

    }
    if (children.length > 1) {
        if (el.tagName.toLowerCase() === 'ul') {
            const ul = el;
            const li = Array.from(children);

            requestAnimationFrame(() => {
                ul.setAttribute('role', 'none');
                li.forEach(child => {
                    child.setAttribute('role', 'none');
                    child.classList.add('li');
                });
            });
        }

        if (!minSlides) {
            minSlides = 1;
        }
        if (children.length > parseFloat(minSlides)) {
            var paginationClass;
            paginationClass = (settings && settings.pagination && settings.pagination.el) || ".swiper-pagination";
            paginationClass = paginationClass.replace(/\./g, " ").trim();

            const dots = createElementWithClass('span', paginationClass);
            const prev = createElementWithClass('span', 'swiper-button-prev');
            const next = createElementWithClass('span', 'swiper-button-next');
            el.classList.add('s4wi');

            prev.classList.add('swiper-button-nav');
            next.classList.add('swiper-button-nav');

            requestAnimationFrame(() => {
                prev.setAttribute('role', 'navigation');
                next.setAttribute('role', 'navigation');
            });

            const slidesFragment = document.createDocumentFragment();

            Array.from(children).forEach(child => {
                const wrapper = document.createElement('div');
                wrapper.classList.add('swiper-slide');
                wrapper.appendChild(child);
                slidesFragment.appendChild(wrapper);
            });

            const swiperFragment = document.createDocumentFragment();

            const swiperOuter = document.createElement('div');
            swiperOuter.className = 'swiper-outer';

            const swiperWrapper = document.createElement('div');
            swiperWrapper.className = 'swiper-wrapper';

            /*while (el.firstChild) {
                swiperWrapper.appendChild(el.firstChild);
            }*/

            swiperOuter.appendChild(swiperWrapper);
            swiperWrapper.appendChild(slidesFragment);
            //el.appendChild(swiperOuter);
            swiperFragment.appendChild(swiperOuter);

            const pagination = document.createElement('div');
            pagination.className = 'swiper-custom-pagination';
            //el.appendChild(pagination);
            swiperFragment.appendChild(pagination);
            el.appendChild(swiperFragment);

            if (settings && settings.pagination) {
                settings.pagination.el = settings.pagination.el || pagination;
                pagination.append(prev, dots, createElementWithClass('span', 'swiper-custom-fraction'), next);
            } else {
                const navFragment = document.createDocumentFragment();
                navFragment.appendChild(prev);
                navFragment.appendChild(next);
                el.appendChild(navFragment);
            }


            if (!settings.navigation) settings.navigation = {};
            settings.navigation.prevEl = prev;
            settings.navigation.nextEl = next;

            const swiperInstance = new Swiper(swiperOuter, settings);

            requestAnimationFrame(() => {
                const paginationBullets = el.querySelectorAll('.swiper-pagination-bullet');
                paginationBullets.forEach(bullet => bullet.setAttribute('role', 'navigation'));
            });

            return swiperInstance;
        }
    }
    if (bg === true) {
        requestAnimationFrame(() => {
            imgOverlays.forEach(imgOverlay => el.appendChild(imgOverlay));
        });
    }

    return null;
}

  function randomize(el) {
    el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1);
  }
  
  function clone_with_class(el, cl1, cl2) {
    const cln = el.cloneNode(true);
    cln.classList.add(cl1);
    el.after(cln);
    el.classList.add(cl2);
  }

  function new_js(el) {
    var tag = document.createElement('script');
    tag.src = el;
    document.body.appendChild(tag);
  }


  function checkIfImageExists(url, callback) {
    const img = new Image();
  
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
  
    img.src = url;
    if (img.complete) {
      img.onload();
    }
  }

  // Assign z-indexes to form elements
  function assignIndex(elements) {
    Array.from(elements).forEach((el, index) => {
      el.style.zIndex = elements.length - index;
    });
  }
  
  //Default.utils.start();
  html_tag.classList.add('js');
  
  //Default.utils.email();
  
  //Default.utils.top();

window.addEventListener("top", function (evt) {
	if (logo_id) {
		const logo_text = logo_id.querySelectorAll('span');
		if (logo_id.parentElement.classList.contains('text-center-logo') && !header_inner.classList.contains('hide-btn')) {
			search_id.classList.add('compact');
		}
		if (logo_text.length) {
			header_inner.classList.add('logo-text');
		}
		const imgWithAlt = logo_id.querySelector('img[alt]');

		if (imgWithAlt) {
			const pt = imgWithAlt.parentNode;

			checkIfImageExists(imgWithAlt.getAttribute('src'), exists => {
				if (!exists) {
					const span = document.createElement('span');
					span.innerHTML = imgWithAlt.getAttribute('alt');
					pt.appendChild(span);
					pt.classList.add('broken-img');
				}
			});
		}
	}

  let calcLogoOffsetScheduled = false;

	function calcLogoOffset() {
    if (calcLogoOffsetScheduled) return;
    calcLogoOffsetScheduled = true;
    requestAnimationFrame(() => {
      if (header_id && logo_id && header_inner.classList.contains('text-center-logo')) {
        const header_width = header_id.getBoundingClientRect().width;
        const offsetPercent = (logo_id.offsetLeft / header_width) * 100 + '%';
        root_styles.style.setProperty('--logo_offset', offsetPercent);
      }
      calcLogoOffsetScheduled = false;
    });
	}

	if (nav_id?.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}

	if (nav_bar_id?.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}

	var navs = document.querySelectorAll('#nav, #nav-bar');

    function checkInv(el, ratio) {
        requestAnimationFrame(() => {
            const el_rect = el.getBoundingClientRect();
            const el_off = global_dir[1] === false ?
                window.innerWidth - el_rect.left - el.offsetWidth :
                el_rect.left;

            if (el_off > window.innerWidth * ratio) {
                el.classList.add('inv');
            } else {
                el.classList.remove('inv');
            }
        });
    }

    /*function countNavDist(el, em, nav) {const nav_id_offset = 0;const d = el.dataset.copy;const f = nav.querySelector(`.show-all li[data-copy="${d}"]`);if (el.classList.contains('temp-hidden')) {el.classList.remove('temp-hidden');if (f) {f.classList.remove('temp-hidden');}}const jf = el.getBoundingClientRect().width;const el_off = (global_dir[1] === false) ? nav.getBoundingClientRect().width - el.offsetLeft - el.getBoundingClientRect().width - nav_id_offset : el.offsetLeft - nav_id_offset;const el_tr = el.parentElement.querySelectorAll('.temp-hidden:not(.show-all)').length > 0 ? 1.2 : 0;if (nav.getBoundingClientRect().width < el_off + el.getBoundingClientRect().width + jf + em * el_tr) {el.classList.add('temp-hidden');if (f) {f.classList.add('temp-hidden');}} else {el.classList.remove('temp-hidden');if (f) {f.classList.remove('temp-hidden');}}}*/

    function countNavDist(el, em, nav) {
        const off_id = 0;
        const dc = el.dataset.copy;
        const show = nav.querySelector(`.show-all li[data-copy="${dc}"]`);

        if (el.classList.contains('temp-hidden')) {
            el.classList.remove('temp-hidden');
            if (show) {
                show.classList.remove('temp-hidden');
            }
        }

        const wdth = el.getBoundingClientRect().width;
        const nwth = nav.getBoundingClientRect().width;
        const off = (global_dir[1] === false) ?
        nwth - el.offsetLeft - wdth - off_id :
        el.offsetLeft - off_id;

        const hcnt = el.parentElement.querySelectorAll('.temp-hidden:not(.show-all)').length;
        const tolr = hcnt > 0 ? 1.2 : 0;
        const buf = 10;

        const calc = off + wdth + wdth + em * tolr + buf;

        if (nwth < calc) {
            el.classList.add('temp-hidden');
            if (show) {
                show.classList.add('temp-hidden');
            }
        } else {
            el.classList.remove('temp-hidden');
            if (show) {
                show.classList.remove('temp-hidden');
            }
        }
    }

    function countNavDistF(el, em, en, nav) {
      let mdc = null;
        function calcNav() {
            if (mediaMin1000.matches) {
                let mdf;
                if (mdc === null) {
                  const mdm = Math.abs(parseFloat(getComputedStyle(el).getPropertyValue('margin-right')));
                  if ((nav.classList.contains('text-justify') || nav.classList.contains('have-text-justify')) && !isNaN(mdm)) {
                    mdc = mdm;
                  } else {
                    mdc = 0;
                  }
                }
                mdf = mdc;
                const replaceTextClass = (originalClass, replacementClass) => {
                    if (nav.classList.contains(originalClass)) {
                        nav.classList.remove(originalClass);
                        nav.classList.add(replacementClass);
                    }
                };
                if (!(el.clientWidth > nav.clientWidth + mdf)) {
                    replaceTextClass('have-text-center', 'text-center');
                    replaceTextClass('have-text-justify', 'text-justify');
                    replaceTextClass('have-text-end', 'text-end');
                } else {
                    replaceTextClass('text-center', 'have-text-center');
                    replaceTextClass('text-justify', 'have-text-justify');
                    replaceTextClass('text-end', 'have-text-end');

                    if (em.length) {
                        en = em[0].getBoundingClientRect().width;
                    }
                    const children = Array.from(el.children);

                    const handleResize = () => {
                        children.forEach(eo => {
                            countNavDist(eo, en, nav);
                        });
                    };
                    handleResize();
                    window.addEventListener('resize', throttle(handleResize, 100));
                }
            }
        }

        calcNav();
        mediaMin1000.addEventListener('change', calcNav);
    }

	if (navs.length) {
		if (nav_outer) {
			top_id.classList.add('has-nav-outer');
		}
		Array.from(navs).forEach(function (nav_main) {
			if (nav_main.closest('#header-inner') !== null) {
				html_tag.classList.add('has-inside-nav');
				// search_id.classList.add('compact');
			} else {
				html_tag.classList.remove('has-inside-nav');
			}

            const nmu = nav_main.querySelector('[data-type]');
            const nms = 0;

            if (nmu !== null) {

                Array.from(nmu.children).forEach(function (el, index) {
                    el.setAttribute('data-copy', nmu.children.length - index);
                });

                const nml = nmu.querySelector('li.show-all');
                if (nml) {
                    const all_submenu = createElementWithClass('ul', 'show-all-submenu');
                    nml.appendChild(all_submenu);

                    const nmt = Array.from(nml.closest('ul').children);
                    const submenu = nml.querySelector('.show-all-submenu');

                    nmt.forEach(el => {
                      if (!el.classList.contains('show-all')) {
                        const clone_me = el.cloneNode(true);
                        submenu.appendChild(clone_me);
                      }
                    });


                    function logoLoad() {
                        calcLogoOffset();
                        countNavDistF(nmu, nml, nms, nav_main);
                        top_id.classList.add('ready');
                        header_id.classList.add('ready');
                    }
                    if (nav_outer) {
                        calcLogoOffset();
                        setTimeout(function () {
                            if (logo_img) {
                                if (logo_img.complete) {
                                    logoLoad();
                                } else {
                                    logo_img.addEventListener('load', logoLoad);
                                }
                            } else {
                                countNavDistF(nmu, nml, nms, nav_main);
                                top_id.classList.add('ready');
                                header_id.classList.add('ready');
                            }
                        }, 250);
                    } else {
                        setTimeout(function () {
                            countNavDistF(nmu, nml, nms, nav_main);
                            header_outer.classList.add('ready');
                        }, 250);
                    }

                    window.addEventListener('resize', throttle(() => {
                        calcLogoOffset();
                        //html_tag.classList.add('has-long-nav');
                        header_outer.classList.remove('ready');
                        countNavDistF(nmu, nml, nms, nav_main);
                        header_outer.classList.add('ready');
                    }, 250));

                    /*if (nav_main.closest('#header-inner') !== null && nav_main.closest('#header-inner').classList.contains('sticky-nav')) {
                        function callback(mutationList, observer) {
                            mutationList.forEach(function (mutation) {
                                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                    var temp_hidden = nav_main.getElementsByClassName('temp-hidden');
                                }
                            });
                        }
                        const observer = new MutationObserver(callback);
                        observer.observe(nav_main, {
                            attributes: true
                        });
                    }*/
                }

                const nmv = nav_main.getElementsByClassName('sub-static');
                if (nmv.length) {
					function executeCheckInv() {
						if (!checkInvExecuted) {
							Array.from(nmv).forEach(function (el) {
								//if (!el.classList.contains('show-all')) {
								checkInv(el, 0.5);
								//}
							});
						}
					}
					let checkInvExecuted = false;

					document.addEventListener('mouseover', function () {
						if (!checkInvExecuted) {
							executeCheckInv();
							checkInvExecuted = true;
						}
					});

          window.addEventListener('resize', throttle(() => {
						checkInvExecuted = false;
						executeCheckInv();
          }, 500));
				}
			}
		});
	}

	if (search_id && header_inner) {
		// if (!isHasSelectorSupported()) {
			if (search_id.classList.contains('no-bg') && !search_id.classList.contains('bd-b')) {
				top_id.classList.add('no-bd-m');
			}
			if (search_id.classList.contains('no-bg')) {
				top_id.classList.add('no-bd');
			}
			if (search_id.classList.contains('no-pd-t')) {
				top_id.classList.add('no-pd-t');
			}
		// }
        if (!search_id.classList.contains('compact') && header_inner.classList.contains('hide-btn') && header_inner.classList.contains('text-center-logo')) {
            search_id.classList.add('not-compact');
            if (search_id.classList.contains('not-compact')) {
                /*enquire.register('screen and (max-width: 1000px)', function () {
                    search_id.classList.add('compact');
                }).register('screen and (min-width: 1001px)', function () {
                    search_id.classList.remove('compact');
                });*/
                function updateSearch() {
                    if (mediaMax1000.matches) {
                        search_id.classList.add('compact');
                    } else if (mediaMin1000.matches) {
                        search_id.classList.remove('compact');
                    }
                }

                updateSearch();

                mediaMax1000.addEventListener('change', updateSearch);
                mediaMin1000.addEventListener('change', updateSearch);
            }
        }
	}

	// If #nav exists, create a #nav-top for mobile menu
	/*if (nav_id && nav_top_id && !nav_id.querySelectorAll('ul.nav-top').length) {
        Array.from(nav_top_id.querySelectorAll('ul[data-type]')).forEach(function (el) {
            var clone_me = el.cloneNode(true);
            clone_me.classList.add('nav-top');
            nav_id.appendChild(clone_me);
        });
    }*/

	// Detect empty URLs
	if (nav_main) {
		Array.from(nav_main.querySelectorAll('a[href="#"]')).forEach(el => {
			const parent = el.parentElement;
			if (parent) {
				parent.classList.add('empty-url');
			}
		});
	}

    var a_accessible = document.getElementsByClassName('link-accessible');
    function accessibleLink(el) {
      if (html_tag.classList.contains('t1ac')) {
          html_tag.classList.remove('t1ac');
          Cookies.set('accessible', 'no');
      } else {
          new_css('accessible-mode-css', window.filepaths['theme_accessible_css']);
          html_tag.classList.add('t1ac');
          Cookies.set('accessible', 'yes');
      }
      if (nav_id || nav_bar_id) {
          var temp_hidden = nav_main.getElementsByClassName('temp-hidden');
          setTimeout(function () {
              Array.from(temp_hidden).forEach(function (el) {
                  el.classList.remove('temp-hidden');
              });
              window.dispatchEvent(new Event('resize'));
          }, 100);
      }
    }
    if (a_accessible.length) {
        Array.from(a_accessible).forEach(function (el) {
            el.parentElement.classList.add('has-link-accessible');
        });
        html_tag.addEventListener('click', function (event) {
            if (event.target.matches('a.link-accessible, a.link-accessible *')) {
                accessibleLink(event.target.closest('a.link-accessible'));
                event.preventDefault();
            }
        });
        html_tag.addEventListener('keyup', function (event) {
            if (event.key === ' ' && event.target.matches('a.link-accessible, a.link-accessible *')) {
                accessibleLink(event.target.closest('a.link-accessible'));
                event.preventDefault();
            }
        });
    }
  if (Cookies.get('accessible') === 'yes') {
    new_css('accessible-mode-css', window.filepaths['theme_accessible_css']);
    html_tag.classList.add('t1ac');
  } else {
    html_tag.classList.remove('t1ac');
    Cookies.remove('accessible');
  }

	// Searchbox
	if (search_id) {
		if (search_id.classList.contains('compact-handle')) {
			html_tag.classList.add('t1sh-mobile', 'search-compact-handle');
		} else {
			html_tag.classList.remove('t1sh-mobile', 'search-compact-handle');
		}
		if (search_id.classList.contains('compact-handle-mobile')) {
			html_tag.classList.add('t1sh-mobile', 'search-compact-handle', 'search-compact-handle-mobile');
		} else {
			html_tag.classList.remove('search-compact-handle-mobile');
		}
		if (search_id.classList.contains('compact')) {
			if (search_id.classList.contains('compact-handle')) {
				html_tag.classList.add('t1sh');
			} else {
				html_tag.classList.remove('t1sh');
			}
			html_tag.classList.add('t1sr');
		} else {
			html_tag.classList.remove('t1sr', 't1sh');
		}
		if (search_id.classList.contains('text-center-sticky')) {
			html_tag.classList.add('search-compact-is-centered');
		} else {
			html_tag.classList.remove('search-compact-is-centered');
		}
	}
});

window.dispatchEvent(topEvt);

var breadcrumb_back = document.querySelectorAll('.breadcrumb-back');
if (breadcrumb_back.length) {
	Array.from(breadcrumb_back).forEach(function (el) {
		if (document.referrer.indexOf(window.location.host) !== -1) {
			el.addEventListener('click', function (e) {
				history.go(-1); return false;
			})
		}
		else { el.remove(); }
	})
}

var select_tag = document.getElementsByTagName('select');
window.addEventListener("formZindex", function (evt) {
	// :placeholder-like support for <select> element
	Array.from(select_tag).forEach(el => {
		const parentNode = el.parentNode;
		const closestParagraph = el.closest('p');

		parentNode.classList.add('has-select');
		if (closestParagraph) {
			closestParagraph.classList.add('has-select');
		}

		el.addEventListener('change', () => {
			el.classList.add('changed');
		});
	});

	let handleFormChildrenCalculated = false;
  let handleFormChildrenScheduled = false;
	function handleFormChildren() {
    if (handleFormChildrenScheduled) return;
    handleFormChildrenScheduled = true;
    requestAnimationFrame(() => {
      if (!handleFormChildrenCalculated) {
        const formChildren = document.querySelectorAll(
          'form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *, .l4ca.compact.in-panel > *, .l4cl.box > li, .f8pr-bulk > *'
        );
        if (formChildren.length) {
          assignIndex(formChildren);
        }
        handleFormChildrenCalculated = true;
      }
      handleFormChildrenScheduled = false;
    });
	}
    if (!isMobile) {
        document.addEventListener('mouseover', handleFormChildren, asyncOnce);
    }
    document.addEventListener('keyup', handleFormChildren, asyncOnce);
    document.addEventListener('touchstart', handleFormChildren, asyncPass);
    document.addEventListener('scroll', handleFormChildren, asyncPass);
    window.addEventListener('resize', throttle(handleFormChildren, 500));
});
window.dispatchEvent(formZindexEvt);

function runPaddingsForInputs(element) {
    const prefixSpan = element.querySelector('span:first-child');
    if (prefixSpan) {
        const sibling = prefixSpan.nextElementSibling;
        if (sibling) {
            sibling.style.setProperty('--pdi', prefixSpan.offsetWidth + 'px');
        }
    }
}
requestAnimationFrame(function () {
    Array.from(document.querySelectorAll('[class*="input-"][class*="fix"]')).forEach(runPaddingsForInputs);
});

window.check_limit_event = function() {
	var check_limit = document.querySelectorAll('.check[data-limit]');
	if (check_limit.length) {
		Array.from(check_limit).forEach(function (el) {
			if (!el.classList.contains('check-limit-initialized')) {
				el.classList.add('check-limit-initialized');
				var tag_limit = 'a',
					limit,
					trigger,
					nextAll = false,
					lastDesc;
				if (el.tagName.toLowerCase() === 'ul' || el.tagName.toLowerCase() === 'ol') {
					tag_limit = 'li';
				}
				limit = createElementWithClass(tag_limit, 'limit');
				trigger = el.children[el.dataset.limit - 1];

				if (trigger !== undefined) {
					nextAll = [].filter.call(trigger.parentNode.children, function (htmlElement) {
						return (htmlElement.previousElementSibling === trigger) ? nextAll = true : nextAll;
					});
					nextAll.forEach(function (em) {
						if (!em.classList.contains('hidden')) {
							em.classList.add('hidden-check');
						}
					});
					limit.innerText = '+' + Math.abs(el.querySelectorAll('li:not(.hidden, .tip-cont)').length - el.dataset.limit);
					if (tag_limit = 'li') {
            //limit.innerHTML = '<a href="./">' + limit.innerHTML + '</a>';
            const a = document.createElement('a');
            a.href = './';
            while (limit.firstChild) {
              a.appendChild(limit.firstChild);
            }
            limit.appendChild(a);
					}
					el.append(limit);
					lastDesc = el.querySelector('li.hidden');
					if (lastDesc) {
						el.appendChild(lastDesc);
					}
					Array.from(el.querySelectorAll('a.limit, .limit a')).forEach(function (em) {
						em.addEventListener('click', function (e) {
							el.classList.add('limit-clicked');
							e.preventDefault();
						});
					});
				}
			}
		});
	}
};
check_limit_event();

//Default.utils.footer();
// Change the position of background element (just for security)
window.addEventListener("background", function(evt) {
	// Change the position of background element (just for security)
	if (document.querySelector('#background.done')) {
		document.querySelector('#background.done').remove();
	}
	const background_id = document.getElementById('background');
	if (background_id && !background_id.classList.contains('static') && (background_id.parentNode.id === 'content' || background_id.parentNode.classList.contains('shopify-section'))) {
		document.getElementById('root').appendChild(background_id);
		background_id.classList.add('done');
	}
});
window.dispatchEvent(backgroundEvt);

//Default.utils.tabs();
// Create tabs
window.addEventListener("moduleTabs", function(evt) {
	var tabs_holder = document.querySelectorAll('#content, .m6pn');
	if (tabs_holder.length) {
		Array.from(tabs_holder).forEach(function (el) {
			const module_tabs = el.getElementsByClassName('m6tb');
			if (module_tabs.length) {
				Array.from(module_tabs).forEach(function (el) {
					if (typeof semanticTabs === 'function' && !el.classList.contains('tabs-initialized')) {
						semanticTabs(el);
					}
					el.classList.add('tabs-initialized');
				});
			}
		});
	}
});
window.dispatchEvent(moduleTabsEvt);

//Default.utils.swipers();
var popup_a, list_collection_slider;
window.addEventListener("moduleFeaturedSlider", function(event) {
	const module_featured = document.querySelectorAll('.m6fr:not(.s4wi)');
	if (module_featured.length) {
		Array.from(module_featured).forEach(function (el) {
			var pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				featuredSlider;
			el.querySelectorAll('figure').forEach(function (em) {
				if (em.getElementsByTagName('picture').length > 1) {
					em.classList.add('has-pics');
				}
			});
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true
				};
			}
			randomize(el);
			const randomId = el.getAttribute('data-random');
			featuredSlider = create_slider(el, {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				resizeObserver: true,
				autoplay: autoplay_int,
				threshold: 50,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					type: pagination_type,
					renderBullet: function (index, className) {
						return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
					},
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				on: {
					afterInit: function (swiper) {
						updateSwiper(swiper);
					},
					slideChangeTransitionStart: function (swiper) {
						updateSwiper(swiper);
            Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(function (em) {
              em.parentNode.classList.add('has-aside');
            });
            var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article')[0];
            if (typeof active_content !== 'undefined') {
              el.setAttribute('data-active-content', active_content.getAttribute('class'));
            }
            if (swiper.realIndex > 0) {
              el.classList.add('changed');
            } else {
              el.classList.remove('changed');
            }
            if (swiper.realIndex + 1 === total_sl) {
              el.classList.add('last-slide-active');
            } else {
              el.classList.remove('last-slide-active');
            }
					},
					resize: function (swiper) {
						if (typeof Shopify !== 'undefined' && Shopify.designMode) {
							Array.from(featuredSlider.slides).forEach(function () {
								featuredSlider.slideNext(0);
							});
						}
						setTimeout(function () {
							featuredSlider.updateAutoHeight();
						}, 500);

					}
				}

			});
			function updateSwiper(swiper) {
				Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(em => {
					em.parentNode.classList.add('has-aside');
				});
				/*const active_content = swiper.el.querySelector('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article');
				if (typeof active_content !== 'undefined') {
					el.setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
				}*/
                const active_content = swiper.el.querySelector('.swiper-slide-active > article');
                if (active_content) {
                    el.setAttribute('data-active-content', active_content.getAttribute('class') || '');
                }
				if (swiper.realIndex > 0) {
					el.classList.add('changed');
				} else {
					el.classList.remove('changed');
				}
				if (swiper.realIndex + 1 === total_sl) {
					el.classList.add('last-slide-active');
				} else {
					el.classList.remove('last-slide-active');
				}
			}
			if (featuredSlider !== null) {
				if (el.getAttribute('data-autoplay') && !el.classList.contains('no-controls')) {
					append_url(el, 'Play/Pause', 'play-pause');
					el.querySelector('.play-pause').addEventListener('click', function (e) {
						if (el.classList.contains('paused')) {
							el.classList.remove('paused');
							featuredSlider.autoplay.start();
						} else {
							el.classList.add('paused');
							featuredSlider.autoplay.stop();
						}
						e.preventDefault();
					});
					el.addEventListener('mouseleave', function () {
						if (!el.classList.contains('paused')) {
							featuredSlider.autoplay.start();
						}
					});
				}
        window.addEventListener('resize', throttle(function () {
					html_tag.classList.add('resized');
        }, 200), true);
				setTimeout(function () {
					featuredSlider.updateAutoHeight();
				}, 500);
			}
			if (el.classList.contains('s4wi')) {
				setTimeout(function () {
					if (typeof updateSlidersEvt != 'undefined') {
						window.dispatchEvent(updateSlidersEvt);
					}
				}, 300);
			}
		});
	}
});
window.dispatchEvent(moduleFeaturedSliderEvt);

window.addEventListener("announcementSlider", function(event) {
	let top_bar = document.querySelector('.shopify-section-announcement-bar:not(.s4wi)');
	var top_bar_children = document.querySelectorAll('.shopify-section-announcement-bar:not(.s4wi) > *:not(.close, .overlay-close)');
	if (top_bar && top_bar_children.length > 1 && !top_bar.classList.contains('m6kn')) {
		Array.from(top_bar.querySelectorAll('.close, .overlay-close')).forEach(function (el) {
			el.remove();
		});
		let autoplay_top_int = false;

		const dataAutoplay = top_bar.getAttribute('data-autoplay');
		if (dataAutoplay) {
			autoplay_top_int = {
				delay: parseFloat(dataAutoplay),
				pauseOnMouseEnter: true,
				disableOnInteraction: false
			};
		}
		if (top_bar.querySelector('.no-nav')) {
			top_bar.classList.add('no-nav');
		}
		randomize(top_bar);
		const randomId = top_bar.getAttribute('data-random');
		create_slider(top_bar, {
			direction: 'horizontal',
			loop: true,
			autoHeight: true,
			spaceBetween: window.innerWidth * 0.5,
			autoplay: autoplay_top_int,
			pagination: false
		});
	}
});
window.dispatchEvent(announcementSliderEvt);

window.addEventListener("listTestimonialsSlider", function(event) {
	const list_testimonials = document.querySelectorAll('.l4ts:not(.s4wi)');
	if (list_testimonials.length) {
		Array.from(list_testimonials).forEach(function (el) {
			var ln = [1, 2, 3],
				pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				options;
			if (el.classList.contains('wide') || el.classList.contains('w100')) {
				ln = [1, 1, 1];
			}
			if (el.classList.contains('w50')) {
				ln = [1, 2, 2];
			}
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true,
					disableOnInteraction: false
				};
			}
			randomize(el);
			options = {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				spaceBetween: 16,
				slidesPerView: ln,
				slidesPerGroup: ln,
				autoplay: autoplay_int,
				pagination: {
					el: '.swiper-pagination-' + el.getAttribute('data-random'),
					clickable: true,
					type: pagination_type,
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
				},
				on: {
					slideChangeTransitionStart: function (swiper) {
						swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
						swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
					}
				},
				breakpoints: {
					0: {
						slidesPerView: ln[0],
						slidesPerGroup: ln[0]
					},
					760: {
						slidesPerView: ln[1],
						slidesPerGroup: ln[1]
					},
					1000: {
						slidesPerView: ln[2],
						slidesPerGroup: ln[2]
					}
				}
			};
			if (el.classList.contains('slider') && el.children.length > ln[2]) {
				create_slider(el, options);
			}
			if (el.classList.contains('slider-mobile') && el.children.length > ln[0]) {
				const nextSibling = el.nextElementSibling;
				clone_with_class(el, 'mobile-only', 'mobile-hide');
				if (nextSibling && nextSibling.classList.contains('mobile-only')) {
					if (nextSibling.hasAttribute('id')) {
						nextSibling.removeAttribute('id');
					}
					create_slider(el.nextElementSibling, options);
				}
			}
		});
	}
});
window.dispatchEvent(listTestimonialsSliderEvt);

window.addEventListener("listStaticSlider", function(event) {
  const list_static = document.querySelectorAll('.l4st:not(.static, .s4wi)');
	if (list_static.length) {
		Array.from(list_static).forEach(function (el) {
      //if (!el.classList.contains('static')) {
      //var pagination_type = 'bullets',
      /*if (el.classList.contains('slider-fraction')) {
        pagination_type = 'fraction';
      }*/
      const total_sl = el.children.length;
      const pagination_type = el.classList.contains('slider-fraction') ? 'fraction' : 'bullets';

      let autoplay_int = false;
      const autoAttr = el.getAttribute('data-autoplay');
      if (autoAttr) {
        autoplay_int = {
          delay: parseFloat(autoAttr),
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        };
      }
      randomize(el);
      const randomId = el.getAttribute('data-random');
      clone_with_class(el, 'mobile-only', 'mobile-hide');

      const nextEl = el.nextElementSibling;
      if (nextEl && nextEl.classList.contains('mobile-only')) {
        if (nextEl.hasAttribute('id')) {
          nextEl.removeAttribute('id');
        }
        create_slider(nextEl, {
          direction: 'horizontal',
          loop: true,
          autoHeight: true,
          spaceBetween: 16,
          autoplay: autoplay_int,
          pagination: {
            el: `.swiper-pagination-${randomId}`,
            clickable: true,
            type: pagination_type,
            renderFraction: function (currentClass, totalClass) {
              return '<span class="' + currentClass + '"></span>' +
                ' <span class="slash">/</span> ' +
                '<span class="' + totalClass + '"></span>';
            }
          },
          on: {
            slideChangeTransitionStart: function (swiper) {
              const parent = swiper.el.parentNode;
              parent.classList.toggle('changed', swiper.realIndex > 0);
              parent.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
              /*if (swiper.realIndex > 0) {
                swiper.el.parentNode.classList.add('changed');
              } else {
                swiper.el.parentNode.classList.remove('changed');
              }
              if (swiper.realIndex + 1 === total_sl) {
                swiper.el.parentNode.classList.add('last-slide-active');
              } else {
                swiper.el.parentNode.classList.remove('last-slide-active');
              }*/
            }
          }
        });
      }
			/*if (el.classList.contains('slider')) {
                randomize(el);
            }*/
		});
	}
});
window.dispatchEvent(listStaticSliderEvt);

window.addEventListener("listUspSlider", function(event) {
	let list_usp = document.querySelectorAll('.l4us:not(.s4wi)');
	if (list_usp.length) {
		Array.from(list_usp).forEach(function (el) {
			if (!el.classList.contains('static')) {
				let autoplay_int = false;
				let autowidth_int = 1;
				let space_between;

				if (el.classList.contains('no-arrows')) {
					space_between = 16;
				} else {
					space_between = 44;
				}

				if (el.hasAttribute('data-autoplay')) {
					autoplay_int = {
						delay: parseFloat(el.getAttribute('data-autoplay')),
						pauseOnMouseEnter: true,
						disableOnInteraction: false
					};
				}
				if (el.querySelectorAll('li').length === 1) {
					el.classList.remove('slider', 'slider-single');
				}
				if (el.closest('#nav-top') !== null && el.classList.contains('slider')) {
					el.classList.add('slider-in-header');
					if (!el.classList.contains('slider-single')) {
						autowidth_int = 'auto';
					}
				}
				const options = {
					direction: 'horizontal',
					loop: true,
					pagination: false,
					autoplay: autoplay_int,
					slidesPerView: autowidth_int,
					autoHeight: true,
					//spaceBetween: 10,
					spaceBetween: space_between,
					breakpoints: {
						0: {
							slidesPerView: 1
						},
						760: {
							slidesPerView: autowidth_int
						},
						1000: {
							spaceBetween: space_between
						},
						1100: {
							spaceBetween: 20
						}
					}
				};
				if (!el.classList.contains('mobile-static')) {
					if (el.classList.contains('slider')) {
						create_slider(el, options);
					} else if (el.childNodes.length > 1) {
						clone_with_class(el, 'l4us-mobile', 'mobile-hide');
            const nextEl = el.nextElementSibling;
            if (nextEl.classList.contains('l4us-mobile')) {
              nextEl.classList.remove('slider', 'slider-in-header');
              if (nextEl.hasAttribute('id')) {
                nextEl.removeAttribute('id');
							}
              create_slider(nextEl, options);
						}
					}
				}
			}
		});
	}
});
window.dispatchEvent(listUspSliderEvt);

popup_a = document.getElementsByClassName('popup-a');
if (popup_a.length) {
	Array.from(popup_a).forEach(function (el) {
		Array.from(el.getElementsByClassName('l4cl')).forEach(function (el) {
			el.classList.add('in-popup');
		});
	});
}

list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)');
const module_collection = document.getElementsByClassName('m6cl');
if (module_collection.length) {
	Array.from(module_collection).forEach(function (el) {
		Array.from(el.querySelectorAll('.l4cl.slider:not(.w12, .w14, .w16, .w20, .w25, .w33, .w50)')).forEach(function (el) {
			el.classList.add('in-col');
		});
	});
}

const list_collection = document.getElementsByClassName('l4cl');
if (list_collection.length) {
    requestAnimationFrame(() => {
        Array.from(list_collection).forEach(el => {
            //if (el.classList.contains('hr')) {
            if (el.clientHeight < el.scrollHeight) {
                el.classList.add('is-scrollable');
            }
        });
        //}
    });
    Array.from(list_collection).forEach(el => {
        if (!isHasSelectorSupported()) {
            Array.from(el.querySelectorAll('.small a')).forEach(em => {
                em.classList.add('has-link');
            });
            Array.from(el.querySelectorAll('div.box')).forEach(em => {
                const closestLi = em.closest('li');
                if (closestLi) {
                    closestLi.classList.add('has-div-box');
                }
            });

            const l4mlElements = el.querySelectorAll('[class*="l4ml"]');
            Array.from(l4mlElements).forEach(em => {
                const closestLi = em.closest('li');
                if (closestLi) {
                    closestLi.classList.add('has-l4ml');
                }
            });

            const pictureElements = el.querySelectorAll('picture ~ picture');
            Array.from(pictureElements).forEach(em => {
                const closestLi = em.closest('li');
                if (closestLi) {
                    closestLi.classList.add('has-picture-picture');
                }
            });
        }
    });
}

window.addEventListener("listCollectionSlider", function(event) {
	list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)');
	if (list_collection_slider.length) {
        Array.from(list_collection_slider).forEach(function (el) {
            let items;
            let hasImg = false;
            let autoHeight = true;
            let loopMe = false;
            let spacing = 16;
            let allowTouch = true;
            let allowTouch_760 = true;
            let autoPlayMe = false;
            let autoPlaySpeed = 300;

            const figureElement = el.querySelector('figure:not(:last-child)');
            const closestTabs = el.closest('.m6tb');

            if (el.matches('[style*="--dist_a"]')) {
                const dist_a_value = getComputedStyle(el).getPropertyValue('--dist_a').trim();
                if (dist_a_value && dist_a_value !== 'px') {
                    const dist_a = parseFloat(dist_a_value);
                    if (!isNaN(dist_a)) {
                        spacing = dist_a;
                    }
                }
            }

            if (figureElement) {
                hasImg = true;
            } else {
                el.classList.add('no-img');
            }

            if (el.classList.contains('slider-loop')) {
                loopMe = true;
            }

            if (el.classList.contains('autoplay')) {
                autoPlayMe = {
                    delay: 0,
                };
                loopMe = true;
                autoPlaySpeed = el.children.length * 1000;
            }

            if (el.classList.contains('static-height') && !el.classList.contains('align-stretch')) {
                autoHeight = false;
            }

            if (el.classList.contains('static-height') || el.classList.contains('align-center') || el.classList.contains('align-stretch')) {
                allowTouch = true;
            }

            if (el.classList.contains('mobile-compact')) {
                allowTouch_760 = false;
            }

            if (el.classList.contains('text-justify') || el.classList.contains('auto-width')) {
                items = ['auto', 'auto', 'auto'];
                autoHeight = false;
            } else {
                const itemsMap = {
                    'in-col': [4, 4, 3],
                    'w8': [12, 6, 4],
                    'w9': [11, 6, 4],
                    'w10': [10, 6, 4],
                    'w11': [9, 6, 4],
                    'w12': [8, 6, 4],
                    'w14': [7, 6, 4],
                    'w16': [6, 5, 3],
                    'w20': [5, 5, 3],
                    'w25': [4, 4, 3],
                    'w33': [3, 3, 3],
                    'w50': [2, 2, 2]
                };

                items = [5, 5, 3];

                for (const cls in itemsMap) {
                    if (el.classList.contains(cls)) {
                        items = itemsMap[cls];
                        break;
                    }
                }
            }

            function handleInit(swiper) {
                if (!hasImg) return;
                const fig = el.querySelector('.swiper-slide-active figure');
                if (fig && fig.offsetHeight > 0) {
                    el.style.setProperty('--fih', fig.offsetHeight + 'px');
                } else {
                    el.style.removeProperty('--fih');
                }
            }
            const throttledHandleInit = throttle(handleInit, 100);

            randomize(el);
            const randomId = el.getAttribute('data-random');
            create_slider(el, {
                direction: 'horizontal',
                loop: loopMe,
                autoHeight: autoHeight,
                slidesPerView: items[0],
                focusableElements: 'input',
                spaceBetween: spacing,
                // centeredSlides: centered,
                touchStartPreventDefault: false,
                lazy: {
                    loadPrevNext: true
                },
                pagination: {
                    el: '.swiper-pagination-' + randomId,
                    clickable: true
                },
                autoplay: autoPlayMe,
                speed: autoPlaySpeed,
                breakpoints: {
                    0: {
                        simulateTouch: false,
                        allowTouchMove: false
                    },
                    760: {
                        slidesPerView: items[2],
                        simulateTouch: allowTouch_760,
                        allowTouchMove: allowTouch_760
                    },
                    1000: {
                        slidesPerView: items[1],
                        simulateTouch: allowTouch,
                        allowTouchMove: allowTouch
                    },
                    1100: {
                        slidesPerView: items[0],
                        simulateTouch: allowTouch,
                        allowTouchMove: allowTouch
                    }
                },
                on: {
                    afterInit: function (swiper) {
                        if (closestTabs) {
                            setTimeout(handleInit, 100);
                        }
                        if (typeof lazyVideoEvt !== 'undefined') {
                            window.dispatchEvent(lazyVideoEvt);
                        }
                        handleInit();
                    },
                    resize: throttledHandleInit,
                    transitionStart: function (swiper) {
                        swiper.el.classList.add('transition');
                    },
                    transitionEnd: function (swiper) {
                        swiper.el.classList.remove('transition');
                        handleInit();
                    }
                }
            });
            Array.from(el.getElementsByClassName('has-text')).forEach(function (em) {
                em.parentElement.classList.add('has-text');
            });
            Array.from(el.getElementsByClassName('cols')).forEach(function (em) {
                em.parentElement.classList.add('has-cols');
            });


            if (hasImg && closestTabs && closestTabs.children.length > 0) {
                const links = closestTabs.children[0].querySelectorAll('a');
                links.forEach(link => {
                    link.addEventListener('click', () => setTimeout(handleInit, 100));
                });
            }

            if (hasImg) {
                const closestSubLi = el.closest('li.sub');
                if (closestSubLi) {
                    closestSubLi.addEventListener('mouseenter', () => {
                        setTimeout(handleInit, 100);
                    });
                }
            }
            const wrapperId = el.querySelector('.swiper-wrapper[id]');
            if (wrapperId) {
                wrapperId.removeAttribute('id');
                Array.from(el.querySelectorAll('.swiper-button-nav[aria-controls]')).forEach(em => {
                    em.removeAttribute('aria-controls');
                });
            }
        });
	}
});
window.dispatchEvent(listCollectionSliderEvt);

window.addEventListener("listProductSlider", function(event) {
    const list_product_slider = document.querySelectorAll('.l4pr:not(.s4wi, .l4pr-initialized)');
    if (list_product_slider.length) {
        html_tag.classList.add('t1pr');
        Array.from(list_product_slider).forEach(function (el) {
            el.classList.add('l4pr-initialized');
			var hasStickyNote = false;
			var stickyNote = [];
			if (el.classList.contains('static')) {
				var clone_me = el.cloneNode(true);
				clone_me.classList.remove('static');
				clone_me.classList.add('desktop-hide');
				el.classList.add('desktop-only');
				el.after(clone_me);
				el = el.nextElementSibling;
			}
			var mainSliderElement = el,
				children = mainSliderElement.children,
				qttChildren = children.length,
				total_sl = el.children.length,
				mainSlider,
				slides,
				initial_slide = 0;

      const stickyNotes = mainSliderElement.querySelectorAll('li.sticky');
      if (stickyNotes.length) {
        hasStickyNote = true;
        stickyNote = Array.from(stickyNotes);
        stickyNotes.forEach(child => child.remove());
      }

			const firstModel = mainSliderElement.querySelectorAll('a > .model-3d:first-child model-viewer[poster]');
			Array.from(firstModel).forEach(em => {
				const staticPosterWrapper = document.createElement('picture');
				const posterSrc = em.getAttribute('poster');

				const staticPoster = document.createElement('img');
				staticPoster.setAttribute('src', posterSrc);
				staticPoster.setAttribute('data-src', posterSrc);
				staticPosterWrapper.prepend(staticPoster);

				staticPosterWrapper.classList.add('just-poster');

				const altAttribute = em.getAttribute('alt');
				if (altAttribute) {
					staticPoster.setAttribute('alt', altAttribute);
				}

				const closestLink = em.closest('a');
				if (closestLink) {
					closestLink.prepend(staticPosterWrapper);
				}
			});

			if (!el.classList.contains('thumbs-static') && !el.classList.contains('thumbs-slider')) {
				const fifthChild = children[4];

				if (fifthChild) {
					fifthChild.classList.add('more');
					append_url(fifthChild, '+' + (qttChildren - 5), 'more');
				}
			}

			const featuredMediaPosition = el.getAttribute('data-featured_media_position');
			if (featuredMediaPosition) {
				initial_slide = parseFloat(featuredMediaPosition) - 1;
			}

			// clone all slides before swiper uses them and change the DOM - used to create custom pagination
			slides = mainSliderElement.cloneNode(true).children;
			Array.from(el.getElementsByClassName('m6bx')).forEach(em => {
				em.classList.add('m6bx-inside');
				el.firstElementChild.appendChild(em);
				em.parentElement.removeChild(em);
			});
			randomize(el);
			const randomId = el.getAttribute('data-random');
			function setNavigationHeight(swiper) {
				const h = `${swiper.height}px`;
                swiper.navigation.prevEl.style.height = h;
                swiper.navigation.nextEl.style.height = h;
            }
			mainSlider = create_slider(mainSliderElement, {
				direction: 'horizontal',
				loop: false,
				autoHeight: true,
				preloadImages: false,
				initialSlide: initial_slide,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					renderBullet: function (index, className) {
						var finalSpan = document.createElement("a"),
							img_type,
							add_class,
							img,
							divFlex,
							moreLink,
							icon,
							span,
							a_thumb,
							a_thumb_img,
							a_thumb_pic,
							a_thumb_pic_class;
						finalSpan.classList.add(className);
						if (slides[index].hasAttribute('class')) {
                            add_class = slides[index].getAttribute('class');

                            const orientationClasses = ['portrait', 'landscape', 'square', 'stripe'];

                            orientationClasses.forEach(orientation => {
                                if (add_class.includes(orientation)) {
                                    finalSpan.classList.add(`orientation-${orientation}`);
                                }
                            });
                            if (add_class.includes('auto')) {
                                finalSpan.classList.add('auto');
                                finalSpan.classList.remove('landscape', 'portrait');
                            }
						}
						if (slides[index].querySelector("picture")) {
							img_type = 'picture';
						} else {
							img_type = 'img';
						}
						img = slides[index].querySelector(img_type);
						if (img !== null) {
							const a_thumb = img.closest('a[data-gallery-thumb]');
							const a_thumb_img = document.createElement('img');
							const a_thumb_pic = document.createElement('picture');

							if (a_thumb) {
								const thumbSrc = a_thumb.getAttribute('data-gallery-thumb');
								a_thumb_img.setAttribute('src', thumbSrc);
                a_thumb_img.setAttribute('loading', 'lazy');

								const a_thumb_pic_class = a_thumb.querySelector('picture[class]');
								if (a_thumb_pic_class) {
									const classValue = a_thumb_pic_class.getAttribute('class');
									const classes = classValue.split(' ');
									classes.forEach(className => {
                                        if (className) {
                                            a_thumb_pic.classList.add(className);
                                        }
									});
								}

								a_thumb_img.setAttribute('alt', 'Thumbnail');
								a_thumb_pic.appendChild(a_thumb_img);
								finalSpan.appendChild(a_thumb_pic);
							} else if (img) {
								finalSpan.appendChild(img);
							}
						}

						divFlex = document.createElement("span");

						moreLink = slides[index].querySelector("a.more");
						if (moreLink && ((qttChildren - 1) - index) > 0) {
							span = document.createElement("span");
							span.innerText = '+' + ((qttChildren - 1) - index).toString();

							divFlex.appendChild(span);
							finalSpan.classList.add('has-more');
							if (slides[index].querySelectorAll('a[data-fancybox]')) {
								Array.from(slides[index].querySelectorAll('a[data-fancybox]')).forEach(function (em) {
									finalSpan.setAttribute('href', em.getAttribute('href'));
								});
							}
						}

						icon = slides[index].querySelector("i[class^=icon-]");
						if (icon) {
							divFlex.appendChild(icon);
						}

						finalSpan.appendChild(divFlex);

						return finalSpan.outerHTML;
					}
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
				},
				on: {
					// "this" keyword within event handler always points to Swiper instance (from documentation https://swiperjs.com/swiper-api#events)
					activeIndexChange: function () {
						var activeIndex = this.activeIndex;
						Array.from(this.el.parentNode.getElementsByClassName('custom-progressbar-inner')).forEach(function (el) {
							el.style.width = 100 * (activeIndex + 1) / qttChildren + '%';
						});
					},
					afterInit: function (swiper) {
						// create progress bar
						const progress_bar = createElementWithClass('div', 'custom-progressbar');
            //progress_bar.innerHTML = '<div class="custom-progressbar-inner" style="width:' + 100 / qttChildren + '%;"></div>';
            const progress_bar_inner = document.createElement('div');
            progress_bar_inner.className = 'custom-progressbar-inner';
            progress_bar_inner.style.width = (100 / qttChildren) + '%';
            progress_bar.appendChild(progress_bar_inner);

						swiper.el.appendChild(progress_bar);

						Array.from(swiper.el.querySelectorAll('.s1lb, .label')).forEach(em => {
							swiper.el.parentNode.appendChild(em);
						});
						Array.from(swiper.el.getElementsByClassName('m6bx-inside')).forEach(em => {
							swiper.el.appendChild(em);
						});

						let custom_fraction;
						if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
							custom_fraction = swiper.el.parentNode.querySelector('.swiper-custom-fraction');
              //custom_fraction.innerHTML = '<span class="swiper-pagination-current">1</span> <span class="slash">/</span> <span class="total-el">' + swiper.slides.length + '</span>';
              const current = document.createElement('span');
              current.className = 'swiper-pagination-current';
              current.textContent = '1';
              const slash = document.createElement('span');
              slash.className = 'slash';
              slash.textContent = '/';
              const total = document.createElement('span');
              total.className = 'total-el';
              total.textContent = swiper.slides.length;
              custom_fraction.append(
                current,
                document.createTextNode(' '),
                slash,
                document.createTextNode(' '),
                total
              );
						}

						setTimeout(function () {
							setNavigationHeight(swiper);
						}, 300);
					},
					slideChangeTransitionEnd: function (swiper) {
						setTimeout(function () {
							setNavigationHeight(swiper);
						}, 300);
					},
					slideChangeTransitionStart: function (swiper) {
						setTimeout(function () {
							if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
								var custom_fraction = swiper.el.parentNode.getElementsByClassName('swiper-pagination-current')[0];
								custom_fraction.innerHTML = swiper.realIndex + 1;
								if (swiper.realIndex > 0) {
									swiper.el.classList.add('changed');
								} else {
									swiper.el.classList.remove('changed');
								}
							}
							if (swiper.realIndex + 1 === total_sl) {
								swiper.el.classList.add('last-slide-active');
							} else {
								swiper.el.classList.remove('last-slide-active');
							}
						}, 300);
					},
					resize: function (swiper) {
						setNavigationHeight(swiper);
					}
				}
			});

			if (hasStickyNote = true) {
				stickyNote.forEach(function (imgOverlay) {
					const swiperOuter = el.querySelector('.swiper-outer');
					if (swiperOuter !== null) {
						swiperOuter.appendChild(imgOverlay);
					} else {
						el.appendChild(imgOverlay);
					}
				});
			}

			if (el.classList.contains('thumbs-slider')) {
				const randomIdSelector = '[data-random="' + randomId + '"]';
				const bulletsSelector = `${randomIdSelector} .swiper-pagination-bullets`;
				const customBullets = el.querySelector(bulletsSelector);

				clone_with_class(customBullets, 'cloned', 'hidden');

				const clonedBullets = el.querySelector(`${bulletsSelector}.cloned`);

				Array.from(clonedBullets.children).forEach((bullet, index) => {
					bullet.setAttribute('data-l4pr-index', index);
				});

				create_slider(clonedBullets, {
					direction: 'horizontal',
					loop: false,
					autoHeight: false,
					slidesPerView: 'auto',
					navigation: {
						nextEl: `${bulletsSelector} .swiper-button-next`,
						prevEl: `${bulletsSelector} .swiper-button-prev`
					}
				});
			}

      /*const data_update_product_slider = document.querySelectorAll('[data-l4pr-index]');
      if (data_update_product_slider.length) {
        Array.from(data_update_product_slider).forEach(el => {
          const isOption = el.tagName.toLowerCase() === 'option';
          const clickHandler = e => {
            const index = parseInt(el.getAttribute('data-l4pr-index'));
            mainSlider.slideTo(index);

            if (el.tagName.toLowerCase() === 'a' && el.classList.contains('swiper-pagination-bullet')) {
              const slide = el.closest('.swiper-slide');
              const siblings = Array.from(getSiblings(slide));

              siblings.forEach(em => {
              em.firstElementChild.classList.remove('swiper-pagination-bullet-active');
              });

              el.classList.add('swiper-pagination-bullet-active');
              e.preventDefault();
            }
          };

          if (isOption) {
            const em = el.parentNode;
            em.addEventListener('change', () => {
              const dx = em.options[em.selectedIndex].getAttribute('data-l4pr-index');
              if (dx !== null) {
                mainSlider.slideTo(dx);
              }
            });
          } else {
            el.addEventListener('click', clickHandler);
          }
        });
      }*/
		});
	}
});
window.dispatchEvent(listProductSliderEvt);

//Default.utils.ratings();
window.addEventListener("ratings", function(evt) {
	const ratingElements = document.querySelectorAll('[data-val][data-of]:not(.rating-initialized)');

	if (ratingElements.length) {
		Array.from(ratingElements).forEach(el => {
			el.classList.add('rating-initialized');
			const fragment = document.createDocumentFragment();
			const reviewsElem = createElementWithClass('span', 'rating-label');
			const reviews = el.innerHTML;
			const rating = el.dataset.val;
			const total = el.dataset.of;

			const isNotS1ld = !(el.classList.contains('s1ld') || el.classList.contains('s1br'));

			if (isNotS1ld) {
				fragment.appendChild(createRatingsHtmlElement(rating, total));
				reviewsElem.innerHTML = reviews;
			} else {
				reviewsElem.innerHTML = `<span class="bar" style="width: ${rating / total * 100}%;"></span>`;
			}

			fragment.appendChild(reviewsElem);
			el.textContent = '';
			el.appendChild(fragment);
		});
	}
});
window.dispatchEvent(ratingsEvt);

const alignMiddleElements = document.getElementsByClassName('align-middle');
const alignCenterElements = document.getElementsByClassName('align-center');

function checkAndAddClass(elements, className) {
	if (elements.length) {
		Array.from(elements).forEach(el => {
			const parent = el.parentNode;
			const grandparent = parent.parentNode;

			const isCenterElement = (
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.id === 'content') ||
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.previousElementSibling === null && parent.nextElementSibling === null && grandparent.id === 'content')
			);

			if (isCenterElement) {
				document.getElementById('content').classList.add(className);
			}
		});
	}
}

//Default.utils.background();
checkAndAddClass(alignMiddleElements, 'align-center');
checkAndAddClass(alignCenterElements, 'align-center-static');

if (!isHasSelectorSupported()) {
	const list_featured_content_box = document.querySelectorAll('.l4ft .content.box');
	if (list_featured_content_box.length) {
		Array.from(list_featured_content_box).forEach(el => {
			const closestLi = el.closest('li');
			if (closestLi) {
				closestLi.classList.add('has-content-box');
			}
		});
	}
}

//Default.utils.mobile();
if (isMobile) {
	html_tag.classList.add('mobile');
} else {
	html_tag.classList.add('no-mobile');
}

//Default.utils.done();
new_js(window.filepaths['custom_async_js']);

window.addEventListener("mediaFlexbile", function(evt) {
  const media_flexible = document.getElementsByClassName('media-flexible');
  if (media_flexible.length) {
    Array.from(media_flexible).forEach(function (el) {
      if ((!el.parentElement.classList.contains('flexible-stack') && (el.classList.contains('slider-mobile') || el.parentElement.classList.contains('mobile-static'))) && (!el.classList.contains('media-flexible-initialized'))) {
        var cloned_mobile, link, emc, pt = el.parentElement,
          tag = document.createElement('div'),
          fl = pt.querySelectorAll('.media-flexible:not(.mobile-hide-media-flexible) > *:not(.mobile-hide-media-flexible)');
        if (!el.parentElement.getElementsByClassName('media-flexible-mobile').length) {
          tag.classList.add('media-flexible-mobile');
          el.after(tag);
          el.classList.add('mobile-hide');
          const cloned_mobile = pt.querySelector('.media-flexible-mobile');
          Array.from(fl).forEach(function (em) {
            emc = em.cloneNode(true);
            cloned_mobile.appendChild(emc);
          });
  
          if (cloned_mobile.classList.contains('media-flexible-mobile')) {
            cloned_mobile.classList.remove('media-flexible', 'mobile-hide');
            if (cloned_mobile.hasAttribute('id')) {
              cloned_mobile.removeAttribute('id');
            }
  
            Array.from(cloned_mobile.children).forEach(function (el) {
              if (el.classList.contains('mobile-hide')) {
                el.remove();
              }
            });
            randomize(cloned_mobile);
            const randomId = cloned_mobile.getAttribute('data-random');
            if (!cloned_mobile.classList.contains('s4wi')) {
              create_slider(cloned_mobile, {
                direction: 'horizontal',
                loop: true,
                autoHeight: true,
                pagination: {
                  el: '.swiper-pagination-' + randomId,
                  clickable: true,
                  type: 'bullets',
                  renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
                  }
                },
                on: {
                  slideChangeTransitionStart: function (swiper) {
                    var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > *')[0];
                    if (typeof active_content !== 'undefined') {
                      el.closest('.m6fr').setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
                    }
                  }
                }
              });
            }
          }
        }
        el.classList.add('media-flexible-initialized');
      }
    });
  }
  });
  window.dispatchEvent(mediaFlexibleEvt);

/*!*/
window.addEventListener("createCols", function(event) {
	var servicePageElement = document.querySelector('[id$="page-service-info-blocks"]');
	if (servicePageElement != null) {
		if (servicePageElement.parentElement.classList.contains('cols')) {
			var parent = servicePageElement.parentElement;
			var article = servicePageElement.parentElement.querySelector('article.w64.t55');
			if (article) { article.replaceWith(...article.childNodes); }
			parent.replaceWith(...parent.childNodes);
		}

		var anySiblingFound = false;
		var wrapper = document.createElement('div');
		wrapper.classList.add('cols');
		var wrapperInner = document.createElement('article');
		wrapperInner.classList.add('w64','t55');
		wrapper.appendChild(wrapperInner);
		var possibleSiblings = ['shopify-section-page-service-menu', 'shopify-section-faq', 'shopify-section-contact-form', 'shopify-section-google-maps'];

		var findSibling = function() {
			var prevSibling = servicePageElement.previousSibling;
			if (prevSibling) {
				var correctSiblingFound = false;
				for (var i = 0; i < possibleSiblings.length; i++) {
					if (prevSibling.classList.contains(possibleSiblings[i])) {
						correctSiblingFound = true;
						anySiblingFound = true;
						prevSibling.classList.add('w64','t55')
						wrapperInner.appendChild(prevSibling);
					}
				}
				if (correctSiblingFound) {
					findSibling();
				} else {
					for (var i = 1; i < wrapperInner.childNodes.length; i++){
						wrapperInner.insertBefore(wrapperInner.childNodes[i], wrapperInner.firstChild);
					}
					if (anySiblingFound) {
						servicePageElement.parentNode.insertBefore(wrapper, servicePageElement);
						wrapper.appendChild(servicePageElement);
					}
				}
			}
		}
		findSibling();
	}
});
window.dispatchEvent(createColsEvt);

window.addEventListener("showAlert", function(event) {
	var messageText = event.detail.message,
		messageType = event.detail.type,
		messageHeader = event.detail.header ? event.detail.header : false,
		messageOrigin = event.detail.origin ? 'message-' + event.detail.origin : false,
		messageColor = '';
	switch(messageType) {
		case "success":
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_success_text; }
			break;
		case "info":
			messageColor = 'pine';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_info_text; }
			break;
		case "error":
			messageColor = 'rose';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_error_text; }
			break;
		default:
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = ''; }
	}
	var message = '<li class="overlay-'+ messageColor +' '+ messageOrigin +'"><i aria-hidden="true" class="icon-'+ messageType +'"></i><p class="strong">'+ messageHeader +'</p><p>'+ messageText +'</p><a href="./" class="close">Close</a></li>';
	var list_alerts = document.querySelector('.l4al:not(.inline):not(.l4al-trustbadge)');

	if (list_alerts === null) {
		list_alerts = document.createElement("ul");
		list_alerts.classList.add('l4al', 'fixed');
		document.getElementById('root').appendChild(list_alerts);
	}
	if ((messageOrigin && list_alerts.getElementsByClassName(messageOrigin).length == 0) || !messageOrigin) { // Prevent double messages (multiple of the same forms are being triggered when posted in shopfiy)
		list_alerts.innerHTML += message;
	}
	if (typeof alertsEvt != 'undefined') { window.dispatchEvent(alertsEvt); }
}, false);

function scrollToTargetAdjusted(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	el.scrollIntoView({
		block: 'center'
	});
}
let loadMoreItemClicked = localStorage.getItem('loadMoreItemClicked');
if (loadMoreItemClicked != null) {
	let el = document.querySelector('#collection > li > figure > a[href="'+ loadMoreItemClicked +'"], .m6cl .results > div a[href="'+ loadMoreItemClicked +'"], .m6cl .results > .l4ne a[href="'+ loadMoreItemClicked +'"]'),
		url = window.location.href;
	if (el && !url.includes(loadMoreItemClicked)) {
		scrollToTargetAdjusted(el);
		localStorage.removeItem('loadMoreItemClicked');
	} else if (!url.includes(loadMoreItemClicked)) {
		localStorage.removeItem('loadMoreItemClicked');
	}
}

window.addEventListener("lazyVideo", function(evt) {
	var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
	if ("IntersectionObserver" in window) {
		var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(video) {
				if (video.isIntersecting) {
					for (var source in video.target.children) {
						var videoSource = video.target.children[source];
						if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							videoSource.src = videoSource.dataset.src;
						}
					}

					video.target.load();
					video.target.classList.remove("lazy");
					lazyVideoObserver.unobserve(video.target);
				}
			});
		});

		lazyVideos.forEach(function(lazyVideo) {
			lazyVideoObserver.observe(lazyVideo);
		});
	}
});
document.addEventListener("DOMContentLoaded", function() {
	window.dispatchEvent(lazyVideoEvt);
});

// Animations .t1an
var a_js_animations = 'js/plugin-animations.js';
var a_css_animations = 'styles/async-animations.css';
function loadRes(u, c, i) {
	if (html_tag.classList.contains(i)) {
		c();
		return true;
	}
	var s = document.createElement('script');
	s.src = u;
	s.async = true;
	s.onload = c;
	document.body.appendChild(s);
	if (!html_tag.classList.contains(i)) {
		html_tag.classList.add(i);
	}
	return true;
}
// NOTE: this plugin will animate only the elements with the [data-sal] attribute defined.
var data_sal = document.querySelectorAll('[data-sal]');
if (data_sal.length) {
	loadRes(a_js_animations, function () {
		new_css('animations-css', a_css_animations);
		sal({
			threshold: 1,
			once: true
		});
	});
}
// ---- Alternating header ----
/* =========================
   A) Safe SAL loader (optional; unrelated to alternating text)
   ========================= */
// Keep this only if you actually use [data-sal] attributes in your theme.
// It loads sal.js and a CSS file once, and won't crash if helpers are missing.
(() => {
  try {
    const html_tag = window.html_tag || document.documentElement;
    const a_js_animations = 'js/plugin-animations.js';
    const a_css_animations = 'styles/async-animations.css';

    // Minimal CSS injector (in case new_css isn't defined elsewhere)
    const new_css = window.new_css || function (id, href) {
      if (document.getElementById(id)) return;
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    };

    function loadRes(u, c, markerClass) {
      if (html_tag.classList.contains(markerClass)) {
        c && c();
        return true;
      }
      const s = document.createElement('script');
      s.src = u;
      s.async = true;
      s.onload = c || null;
      document.body.appendChild(s);
      html_tag.classList.add(markerClass);
      return true;
    }

    const data_sal = document.querySelectorAll('[data-sal]');
    if (data_sal.length) {
      loadRes(a_js_animations, function () {
        try {
          new_css('animations-css', a_css_animations);
          // If sal() is provided by plugin-animations.js
          if (typeof window.sal === 'function') {
            window.sal({ threshold: 1, once: true });
          }
        } catch (e) {
          // swallow — SAL is optional
          console.warn('SAL init skipped:', e);
        }
      }, 'sal-loaded');
    }
  } catch (e) {
    // swallow — SAL is optional
    console.warn('SAL loader skipped:', e);
  }
})();

/* Alternating headline — stable first paint, font-aware height, single timer */
(() => {
  const TEXTS = ['Healthy', 'Great Tasting', 'Big on Flavour', 'Globally Inspired', 'Chef Created'];

  const DURATION_MS = 6000; // full cycle for each phrase
  const FADE_MS     = 700;  // fade/slide duration
  const OUT_AT      = 0.70; // % of cycle before fade starts

  const controllers = new WeakMap();

  function initAlternator(el) {
    if (!el || controllers.has(el)) return;
    const ctrl = {};
    controllers.set(el, ctrl);

    // Kill any theme animations/transitions on this node
    el.style.animation = 'none';
    el.style.transition = 'none';

    // ---- First paint: instant, no motion ----
    el.textContent = TEXTS[0];
    el.style.display   = 'inline-block';
    el.style.opacity   = '1';
    el.style.transform = 'translateY(0)';

    // Reserve a conservative baseline so layout doesn’t jump while we wait for fonts
    setBaselineMinHeight(el);

    // Commit the first paint
    void el.offsetWidth;

    // Re-enable transitions explicitly (some themes override one prop to 0ms)
    const transitionValue = `opacity ${FADE_MS}ms ease 0ms, transform ${FADE_MS}ms ease 0ms`;
    el.style.transitionProperty = 'opacity, transform';
    el.style.transitionDuration = `${FADE_MS}ms, ${FADE_MS}ms`;
    el.style.transitionTimingFunction = 'ease, ease';
    el.style.transitionDelay = '0ms, 0ms';
    el.style.transition = transitionValue; // final guard

    // Once fonts are ready, re-measure using Poppins metrics (prevents bounce)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => reserveHeight(el, TEXTS));
    } else {
      // Older browsers: do best-effort measurement now
      reserveHeight(el, TEXTS);
    }

    // ---- Alternation loop ----
    let i = 0;
    function tick() {
      // fade/slide old word up
      el.style.opacity   = '0';
      el.style.transform = 'translateY(-1em)';

      setTimeout(() => {
        i = (i + 1) % TEXTS.length;
        el.textContent = TEXTS[i];

        // place below, then slide into place
        el.style.transform = 'translateY(1em)';
        void el.offsetWidth;
        el.style.opacity   = '1';
        el.style.transform = 'translateY(0)';
      }, FADE_MS);

      ctrl.timerId = setTimeout(tick, DURATION_MS);
    }

    // first fade inside the first cycle
    ctrl.timerId = setTimeout(tick, DURATION_MS * OUT_AT);
  }

function setBaselineMinHeight(el) {
  // Don’t reserve too much space before font load, just use 1 line
  const wrap = el.closest('.alternating-wrap') || el;
  const cs = getComputedStyle(el);
  const line = parseFloat(cs.fontSize);
  wrap.style.minHeight = Math.round(line * 1.1) + 'px';
}

function reserveHeight(el, texts) {
  const wrap = el.closest('.alternating-wrap') || el;
  const probe = el.cloneNode(false);
  Object.assign(probe.style, {
    position: 'absolute',
    left: '-9999px',
    top: '0',
    visibility: 'hidden',
    opacity: 0,
    transform: 'none',
    transition: 'none',
    whiteSpace: 'nowrap'
  });
  // Match fonts exactly so measurement reflects Poppins
  const cs = getComputedStyle(el);
  probe.style.cssText += `font:${cs.fontWeight} ${cs.fontSize}/${cs.lineHeight} ${cs.fontFamily}`;
  document.body.appendChild(probe);

  let maxH = 0;
  for (const t of texts) {
    probe.textContent = t;
    maxH = Math.max(maxH, probe.offsetHeight);
  }
  probe.remove();

  wrap.style.minHeight = maxH + 'px';
}

  function initAll(root = document) {
    root.querySelectorAll('.alternating').forEach(initAlternator);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Shopify editor & dynamic DOM
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:block:select', e => initAll(e.target));
  new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes || []) {
        if (n.nodeType === 1) initAll(n);
      }
    }
});
// After fonts are fully loaded, re-measure heights (doesn't affect the loop)
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => {
    document.querySelectorAll('.alternating').forEach(el => {
      reserveHeight(el, TEXTS); // reuse same phrases
    });
  });
}
})();

// This event will be fired when the cart values are recalculated BUNDLER APP
// -------------------------
// Bundler (guarded / optional)
// -------------------------
// Matches the live theme's proven approach: read globals synchronously,
// then relay events. No caching, no de-bounce, no race conditions.
try {
  // Block A: Read Bundler's global variables directly (synchronous, reliable).
  // Bundler.js sets these globals before custom.js runs.
  // This catches the initial values that event listeners would miss.
  if (typeof originalAmount !== 'undefined' &&
      typeof discountedAmount !== 'undefined' &&
      typeof discountAmount !== 'undefined' &&
      typeof originalCartData !== 'undefined') {
    var evt = new CustomEvent('bundler:total_cart_values', {
      detail: {
        total_amount_original:   originalAmount,
        total_amount_discounted: discountedAmount,
        discount_amount:         discountAmount,
        original_cart_object:    originalCartData
      }
    });
    document.dispatchEvent(evt);

    // Make discounted cart total globally available (in cents)
    window.__bndlr_discounted_cents = discountedAmount;
    document.documentElement.setAttribute('data-bndlr-discounted-cents', String(discountedAmount));
    // Fire a simple hook others can listen to
    document.dispatchEvent(new CustomEvent('bndlr:totals-ready', {
      detail: { original: originalAmount, discounted: discountedAmount }
    }));
  }

  // Only call if Bundler is present on this page
  if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
    window.bndlr.updateCartDiscounts();
  }
} catch (e) {
  // noop: Bundler not present on this template
  console.warn('Bundler block skipped:', e);
}

// Block B: Relay Bundler totals to the DOM so other scripts (drawer, page, etc.) can consume them
document.addEventListener('bundler:total_cart_values', function (e) {
  var d = (e && e.detail) || {};
  var orig = Number(d.total_amount_original) || 0;
  var disc = Number(d.total_amount_discounted) || 0;
  if (disc > 0) {
    document.documentElement.setAttribute('data-bndlr-discounted-cents', String(disc));
    document.dispatchEvent(new CustomEvent('bndlr:totals-ready', {
      detail: { original: orig, discounted: disc, source: 'bundler' }
    }));
  }
});

// Block C: Also store on window for scripts that read window.__bndlr_discounted_cents
document.addEventListener('bundler:total_cart_values', function(e) {
  if (!e || !e.detail) return;
  var cents = e.detail.total_amount_discounted;
  if (typeof cents === 'number') {
    window.__bndlr_discounted_cents = cents;
    document.documentElement.setAttribute('data-bndlr-discounted-cents', String(cents));
    document.dispatchEvent(new Event('bndlr:totals-ready'));
  }
});

/* ===== Globo × WFY — race-safe binder (no data-wfy, no injection) ===== */
(function () {
  if (window.WFY_KILLSWITCH) { console.warn('[WFY] Binder disabled'); return; }

  /* ---------- selectors ---------- */
  const GRID_SEL = '#gf-grid';
  const FORM_SEL = '.spf-product__form';
  const BTN_CAND = '.spf-product__form-btn-addtocart, button[name="add"], [type="submit"], .overlay-buy_button';
  const VAR_SEL  = 'select[name="id"].spf-product__variants';
  const QTY_SEL  = '.quantity__input, input[name="quantity"]';

  /* ---------- utils ---------- */
  const raf = (fn) => requestAnimationFrame(fn);
  const nextTick = () => new Promise(r => setTimeout(r, 0));
  const idle = (fn) => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 200 }) : setTimeout(fn, 50));
  const once = (el, flag) => (el[flag] ? true : (el[flag] = true, false));
  const within = (parent, el) => !!(parent && el && parent.contains(el));

  const rafThrottle = (fn) => {
    let lock = false;
    return (scope = document) => {
      if (lock) return;
      lock = true;
      raf(() => { lock = false; fn(scope); });
    };
  };

  /* ---------- theme qty init helper ---------- */
  function fireSemantic(scope = document) {
    // 1) Prep wrappers so the theme can re-init cleanly
    scope.querySelectorAll('#gf-grid .quantity__wrapper.input-amount, #gf-grid .input-amount')
      .forEach(wrap => {
        wrap.classList.remove('semantic-input-initialized');
        wrap.querySelectorAll(':scope > .semantic-amount')
          .forEach(sa => sa.classList && sa.classList.remove('semantic-input-initialized'));

        wrap.querySelectorAll(':scope > a.incr, :scope > a.decr').forEach(a => a.remove());

        const sams = wrap.querySelectorAll(':scope > .semantic-amount');
        if (sams.length > 1) sams.forEach((el, i) => { if (i > 0) el.remove(); });
      });

    // 2) Fire the theme initializer
    try {
      if (window.semanticInputEvt) window.dispatchEvent(window.semanticInputEvt);
      else window.dispatchEvent(new Event('semanticInput'));
    } catch (_) {}

    // 3) Post-pass cleanup after the theme adds its controls
    nextTick().then(() => {
      scope.querySelectorAll('#gf-grid .quantity__wrapper.input-amount').forEach(wrap => {
        wrap.querySelectorAll(':scope .semantic-amount .semantic-amount').forEach(inner => {
          const parent = inner.parentElement;
          while (inner.firstChild) parent.insertBefore(inner.firstChild, inner);
          inner.remove();
        });

        const sams = wrap.querySelectorAll(':scope > .semantic-amount');
        sams.forEach((el, i) => { if (i > 0) el.remove(); });

        const host = wrap.querySelector(':scope > .semantic-amount') || wrap;

        const incrs = host.querySelectorAll(':scope > a.incr');
        incrs.forEach((a, i) => { if (i > 0) a.remove(); });

        const decrs = host.querySelectorAll(':scope > a.decr');
        decrs.forEach((a, i) => { if (i > 0) a.remove(); });
      });
    });
  }

  function ajaxAdd(variantId, qty) {
  const addConfig = {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: String(variantId), quantity: String(qty) })
  };

  return window.wfyCartFetch('/cart/add.js', addConfig)
    .then(r => { if (!r.ok) throw new Error('add fail'); return r.json(); })
    // cart.js is read-only; keep as normal fetch (doesn't cause 409)
    .then(() => fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }))
    .then(r => { if (!r.ok) throw new Error('cart fetch fail'); return r.json(); });
}

  /* ---------- structure helpers ---------- */
  function ensureSubmit(form) { return form.querySelector('.submit') || form; }

  function ensureQtyWrapper(form) {
    const submit = ensureSubmit(form);
    const wrap = form.querySelector('.input-amount, .quantity__wrapper');
    if (!wrap) return null;

    const btn = submit.querySelector(BTN_CAND) || form.querySelector(BTN_CAND);
    const target = btn && (btn.closest('.overlay-buy_button, button, [type="submit"]') || btn);

    try {
      if (target && within(submit, target) && wrap.parentNode !== submit) {
        submit.insertBefore(wrap, target);
      }
    } catch (_) {}
    return wrap;
  }

  function sanitizeButton(btn) {
    if (!btn) return null;

    Array.from(btn.childNodes).forEach(n => {
      if (n.nodeType === 3 && n.textContent.trim()) n.remove();
    });

    let labelSpan = btn.querySelector('span');
    if (!labelSpan) {
      labelSpan = document.createElement('span');
      btn.insertAdjacentElement('afterbegin', labelSpan);
    }

    const label = (btn.getAttribute('aria-label') || labelSpan.textContent || btn.textContent || 'Add to cart').trim();
    labelSpan.classList.add('mobile-hide');
    labelSpan.textContent = label;
    if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', label);

    if (!btn.querySelector('i.icon-cart.mobile-only')) {
      const icon = document.createElement('i');
      icon.className = 'icon-cart mobile-only';
      icon.setAttribute('aria-hidden', 'true');
      btn.appendChild(icon);
    }

    btn.classList.add('overlay-buy_button', 'visible');
    btn.style.display = 'inline-flex';
    btn.style.minHeight = '44px';
    btn.style.alignItems = 'center';
    btn.style.justifyContent = 'center';
    return btn;
  }

  function ensureAddButton(form) {
    const submit = ensureSubmit(form);
    const btn = submit.querySelector(BTN_CAND) || form.querySelector(BTN_CAND);
    return sanitizeButton(btn);
  }

  function ensureGroup2(scope = document) {
    return;
  }
  
  function getCollectionHandle(form) {
  const link =
    form.closest('.spf-product-card, .spf-product, .spf-product__item')?.querySelector('a[href*="/products/"]') ||
    form.querySelector('a[href*="/products/"]');

  if (!link) return null;

  const m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
  return m ? m[1] : null;
}

function getQtyAvailableForVariant(cart, variantId, inventoryQty) {
  const inCart = (cart.items || []).reduce((sum, item) => {
    return sum + (String(item.variant_id) === String(variantId) ? Number(item.quantity || 0) : 0);
  }, 0);

  return Math.max(0, Number(inventoryQty || 0) - inCart);
}

function showQtyValidity(input, msg) {
  if (!input) return;
  input.setCustomValidity(msg || '');
  input.reportValidity();
  setTimeout(() => input.setCustomValidity(''), 100);
}

function getCollectionStockInfo(form, variantId) {
  const handle = getCollectionHandle(form);
  if (!handle || !variantId) return Promise.resolve(null);

  return Promise.all([
    fetch('/products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(r => r.ok ? r.json() : null),

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(r => r.ok ? r.json() : null)
  ]).then(([product, cart]) => {
    if (!product || !cart || !product.variants) return null;

    const variant = product.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return null;

    if (variant.inventory_management !== 'shopify' || variant.inventory_policy !== 'deny') {
      return null;
    }

    return {
      available: getQtyAvailableForVariant(cart, variantId, variant.inventory_quantity)
    };
  });
}
function findCartLineByVariantId(cart, variantId) {
  if (!cart || !cart.items) return null;
  const idx = cart.items.findIndex(item => String(item.variant_id) === String(variantId));
  return idx >= 0 ? String(idx + 1) : null;
}

  /* ---------- per-form binding ---------- */
  function bindForm(form) {
    if (once(form, '__wfyBound')) return;

    form.addEventListener('submit', e => { e.preventDefault(); e.stopPropagation(); });

    ensureQtyWrapper(form);
    const addBtn = ensureAddButton(form);

    const sel = form.querySelector(VAR_SEL);
    const hid = form.querySelector('input[name="id"]');

    function sync() {
      const vid = (sel && sel.value) || (hid && hid.value) || '';
      if (hid && sel) hid.value = sel.value;
      if (addBtn) addBtn.dataset.variantId = vid;
    }
    if (sel && !sel.__wfySel) { sel.__wfySel = true; sel.addEventListener('change', sync); }
    sync();
    
    // Add-to-cart click
if (addBtn && !addBtn.__wfyClick) {
  addBtn.__wfyClick = true;

  addBtn.addEventListener('click', function () {
  const vid   = addBtn.dataset.variantId || (hid && hid.value);
  const qtyEl = form.querySelector(QTY_SEL);
  let qty     = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    let stockMsg = '';
    if (!vid) { console.warn('[WFY] Missing variant id'); return; }

    const isMobile     = window.matchMedia('(max-width: 767px)').matches;
    const isCollection = window.location.pathname.indexOf('/collections/') === 0;
    const shouldOpenDrawer = !(isMobile && isCollection);

    addBtn.disabled = true;
    addBtn.classList.add('is-loading');

    getCollectionStockInfo(form, vid)
      .then(info => {
        if (info) {
          if (qtyEl) {
            qtyEl.setAttribute('max', String(info.available));
          }

          if (info.available <= 0) {
            if (qtyEl) {
              qtyEl.value = '1';
              fireSemantic(form);
              qtyEl.dispatchEvent(new Event('input', { bubbles: true }));
              qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
            showQtyValidity(qtyEl, 'Only 0 serves available');
            throw new Error('__WFY_STOCK_STOP__');
          }

          if (qty > info.available) {
  qty = info.available;
  stockMsg = 'Only ' + info.available + ' serves available.';

  if (qtyEl) {
    qtyEl.value = String(info.available);
    fireSemantic(form);
    qtyEl.dispatchEvent(new Event('input', { bubbles: true }));
    qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  showQtyValidity(qtyEl, stockMsg);
}
        }

        if (shouldOpenDrawer && typeof window.openPanel === 'function') {
          openPanel('cart');
        }

        return ajaxAdd(vid, qty);
      })
      .then(cart => {
          if (stockMsg && window.matchMedia('(min-width: 768px)').matches) {
    const line = findCartLineByVariantId(cart, vid);
    if (line) {
      window.__wfy_last422 = {
        line: String(line),
        msg: stockMsg,
        at: Date.now()
      };
    }
  }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart },
          bubbles: true
        }));

        if (qtyEl) {
          qtyEl.value = '1';
          fireSemantic(form);
          qtyEl.dispatchEvent(new Event('input',  { bubbles: true }));
          qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (window.ajaxCart?.load) {
          window.ajaxCart.load(null, true, false, true);
        }

        if (isMobile && isCollection && typeof window.showAddToCartToast === 'function') {
  const titleNode =
    form.closest('.spf-product-card')?.querySelector('.spf-product-card__title') ||
    form.closest('.spf-product')?.querySelector('.spf-product-card__title') ||
    form.querySelector('.spf-product-card__title');

  const productTitle = titleNode ? titleNode.textContent.trim() : 'Product';

  let message = `${qty} × ${productTitle}<br>added to cart`;
  if (stockMsg) {
    message = `${stockMsg}<br>Added to cart.`;
  }

  window.showAddToCartToast(message);
}
      })
      .catch(err => {
        if (err && err.message === '__WFY_STOCK_STOP__') return;
        console.error('[WFY] add failed', err);
      })
      .finally(() => {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
      });
  });
}

    // First pass: let the theme attach stepper
    fireSemantic(form);

    function wfyCleanup(scope) {
      scope.querySelectorAll('.quantity__wrapper.input-amount, .input-amount').forEach(wrap => {
        wrap.querySelectorAll(':scope .semantic-amount .semantic-amount').forEach(inner => {
          const parent = inner.parentElement;
          while (inner.firstChild) parent.insertBefore(inner.firstChild, inner);
          inner.remove();
        });

        const siblings = wrap.querySelectorAll(':scope > .semantic-amount');
        siblings.forEach((el, i) => { if (i > 0) el.remove(); });

        const host = wrap.querySelector(':scope > .semantic-amount') || wrap;
        host.querySelectorAll(':scope > a.incr').forEach((a, i) => { if (i > 0) a.remove(); });
        host.querySelectorAll(':scope > a.decr').forEach((a, i) => { if (i > 0) a.remove(); });
      });
    }

    nextTick().then(() => {
      wfyCleanup(form);
      fireSemantic(form);
      setTimeout(() => { wfyCleanup(form); fireSemantic(form); }, 120);
    });
  }

  /* ---------- main binder ---------- */
  const bindAll = rafThrottle((scope = document) => {
    const grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    const items = grid.querySelectorAll(
      '.spf-product__item, .spf-product-card, .spf-product, ' + FORM_SEL
    ).length;
    if (!items) return;

    // First pass (fast)
    scope.querySelectorAll(GRID_SEL + ' ' + FORM_SEL).forEach(bindForm);
    ensureGroup2(scope);

    // Second pass (idle) to catch late DOM injections without thrashing
    idle(() => {
      scope.querySelectorAll(GRID_SEL + ' ' + FORM_SEL).forEach(bindForm);
      ensureGroup2(scope);
      setMaxQtyAttributes();
    });
  });
  
    /* ---------- batch-set max qty from inventory ---------- */
  // Runs after Globo renders (including "load more"). Fetches /cart.js
  // once (cached 30s), then each new product's .js, and sets the HTML
  // max attribute so native spin buttons respect stock limits.
  var _cartCache = { data: null, ts: 0 };

  function getCartCached() {
    if (_cartCache.data && Date.now() - _cartCache.ts < 30000) {
      return Promise.resolve(_cartCache.data);
    }
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (cart) { _cartCache.data = cart; _cartCache.ts = Date.now(); }
      return cart;
    });
  }

  function setMaxQtyAttributes() {
    var grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    var forms = grid.querySelectorAll(FORM_SEL);
    if (!forms.length) return;

    // Only process forms that haven't been handled yet
    var newForms = Array.from(forms).filter(function (f) { return !f.__wfyMaxSet; });
    if (!newForms.length) return;

    getCartCached().then(function (cart) {
      if (!cart) return;

      newForms.forEach(function (form) {


        var hid = form.querySelector('input[name="id"]');
        var sel = form.querySelector(VAR_SEL);
        var vid = (sel && sel.value) || (hid && hid.value);
        var qtyEl = form.querySelector(QTY_SEL);
        if (!vid || !qtyEl) return;

        var handle = getCollectionHandle(form);
        if (!handle) return;

        form.__wfyMaxSet = true;

        fetch('/products/' + handle + '.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !product.variants) return;
          var variant = product.variants.find(function (v) {
            return String(v.id) === String(vid);
          });
          if (!variant) return;
          if (variant.inventory_management !== 'shopify' || variant.inventory_policy !== 'deny') return;

          var available = getQtyAvailableForVariant(cart, vid, variant.inventory_quantity);
          if (available > 0) {
            qtyEl.setAttribute('max', String(available));
          }
        })
        .catch(function () {});
      });
    })
    .catch(function () {});
  }

  /* ---------- sanitize & dedupe buttons ---------- */
  function dedupe(scope) {
    (scope || document).querySelectorAll(GRID_SEL + ' ' + FORM_SEL).forEach(form => {
      const btns = Array.from(form.querySelectorAll(BTN_CAND));
      if (btns.length > 1) {
        const keeper = btns.find(b => b.classList.contains('overlay-buy_button')) || btns[0];
        btns.forEach(b => { if (b !== keeper) b.remove(); });
      }
      sanitizeButton(form.querySelector(BTN_CAND));
    });
  }

  /* ---------- single coordinator: bind + dedupe (+ counter) ---------- */
  window.__wfyRenderCount = 0;

  const onRender = rafThrottle((scope = document) => {
    window.__wfyRenderCount++;
    console.log('[WFY] onRender', window.__wfyRenderCount, scope === document ? 'doc' : 'scope');
    bindAll(scope);
    dedupe(scope);
  });

  /* ---------- boot once ---------- */
  const boot = () => {
    onRender(document);
    setTimeout(() => onRender(document), 60);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  const RENDER_EVENTS = [
    'globoFilterRenderCompleted',
    'spf:rendered',
    'SPF:rendered',
    'SPF:afterFilterUpdate',
    'SPF:afterPagination',
    'SPF:afterSort'
  ];

  RENDER_EVENTS.forEach(evt => {
    window.addEventListener(evt, () => onRender(document), { passive: true });
  });

  // Disabled: MutationObserver causes repeated binder passes during Globo injection (flicker / churn)
  const watchGrid = () => {};

  /* ---------- section reloads ---------- */
  document.addEventListener('shopify:section:load', (evt) => {
    const s = evt?.srcElement || document;
    if (s.querySelector(GRID_SEL) || s.querySelector(FORM_SEL)) {
      onRender(s);
      watchGrid();
    }
  }, { passive: true });

})();

document.addEventListener("DOMContentLoaded", () => {
  const getPill = () => document.querySelector("#gf-tree .gf-refine-toggle-mobile");

  const sync = () => {
    const pill = getPill();
    if (!pill) return;
    const open = document.documentElement.classList.contains("offcanvas-open");
    pill.classList.toggle("is-open", open);
  };

  // Initial
  sync();

  // Watch the TRUE state signal
  const moHtml = new MutationObserver(sync);
  moHtml.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

  // Also resync if Globo re-renders the filter DOM
  const tree = document.querySelector("#gf-tree");
  if (tree) {
    const moTree = new MutationObserver(sync);
    moTree.observe(tree, { childList: true, subtree: true });
  }

  // Light extra sync after clicks (helps with animation timing)
  document.addEventListener("click", (e) => {
    if (e.target && e.target.closest && e.target.closest("#gf-tree .gf-refine-toggle-mobile")) {
      requestAnimationFrame(sync);
      setTimeout(sync, 50);
      setTimeout(sync, 200);
    }
  }, true);
});

